export enum CollapsibleSpeed {
	FAST = 'fast',
	SLOW = 'slow',
}
